import HeaderTop from "../../components/Header/HeaderTop.js";
import HeaderBottom from "../../components/Header/HeaderBottom.js";
import HeaderMenu from "../../components/Header/HeaderMenu.js";
import withoutAuthProvider from "../../services/withoutAuthProvider.js";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { actionsSubdomain, subdomainSelector } from "../../redux/subdomain.slice.js";
import { useDispatch, useSelector } from "react-redux";
import PlayStore from "../../assets/images/playstore-2.webp";
import AppStore from "../../assets/images/appstore-2.webp";

export default function Headers() {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [exclusiveData, setExclusiveData] = useState(null);

  const subdomain = useSelector(subdomainSelector);
  const host = window.location.host;

  let hostSubdomain;
  if (host.startsWith("www.")) {
    const parts = host.split(".");
    hostSubdomain = parts.length > 2 ? parts[1] : parts[0];
  } else {
    hostSubdomain = host.split(".")[0];
  }

  // const hostSubdomain = 'exclusive';
  const excludedSubdomains = (process.env.REACT_APP_EXCLUDED_SUBDOMAINS || "caready,staging").split(",");
  const hostFinalSubdomain =
    !excludedSubdomains.includes(hostSubdomain) && !hostSubdomain.includes("localhost")
      ? hostSubdomain
      : "global";

  if (hostFinalSubdomain !== subdomain) {
    dispatch(actionsSubdomain.setSubdomain({ subdomain: hostFinalSubdomain }));
  }

  const toastError = (message) => {
    return toast.error(message, {
      id: "error-message",
      duration: 3000,
    });
  };

  const getExclusive = async () => {
    try {
      const response = await withoutAuthProvider.getDataWithoutAuth(`/api/auction/seller/${subdomain}`);
      if (response?.status === 200) {
        const dat = response?.data.data;
        setExclusiveData(dat);
      } else {
        toastError(response?.data.message);
      }
    } catch (error) {
      toastError(error?.data.message);
    }
  };

  useEffect(() => {
    if (subdomain !== "global") {
      getExclusive();
    }
  }, [subdomain]);

  const headerApps = [
    {
      name: "Play Store",
      image: PlayStore,
      path: "https://play.google.com/store/apps/details?id=com.caready.auction&hl=id",
    },
    {
      name: "App Store",
      image: AppStore,
      path: "https://apps.apple.com/id/app/caready/id6612016320",
    },
  ];

  return (
    <header className="position-fixed top-0 vw-100" style={{ zIndex: "5" }}>
      <HeaderTop headerApps={headerApps} />
      <HeaderBottom setIsOpen={setIsOpen} exclusiveData={exclusiveData} />
      <HeaderMenu isOpen={isOpen} setIsOpen={setIsOpen} exclusiveData={exclusiveData} headerApps={headerApps} />
    </header>
  );
}
